import AliceHappTre from './AliceHappTre.jpg';
import AnnaSvedbergStenaLine from './AnnaSvedbergStenaLine.jpg';
import JohanSkarinAgreat from './JohanSkarinAgreat.jpg';
import kimonSfirisSigma from './kimonSfirisSigma.jpg';
import MartinAnderssonWirelessCar from './MartinAnderssonWirelessCar.jpg';
import MalinPajnertKollmorgen from './MalinPajnertKollmorgen.jpg';
import LeaSavolainenSoftronic from './LeaSavolainenSoftronic.jpg';

export const testimonialImages = {
  AliceHappTre,
  AnnaSvedbergStenaLine,
  JohanSkarinAgreat,
  kimonSfirisSigma,
  MartinAnderssonWirelessCar,
  MalinPajnertKollmorgen,
  LeaSavolainenSoftronic,
};
